import React, { useEffect, useRef, useState } from "react";
import { useInformations } from "../../../hooks/useInformations";

import { useName } from "../../../hooks/useName";

import { IDatetime } from "../../../interfaces/datetime";
import { IStatus } from "../../../interfaces/status";

import { Informations } from "../../Informations";

import { Label } from "../../Label";
import { Checkbox } from "../Checkbox";

import * as S from "./styles";

export const Datetime: React.FC<IDatetime> = (props) => {
  const informationsRef = useRef(null);

  const { informations, onValidate, getInformationsClasses } = useInformations({
    ref: informationsRef,
    inputProps: props,
  });

  const { name } = useName(props.name);

  const [status, setStatus] = useState<IStatus>("VALIDATED");

  const [value, setValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    setValue(props.value as string);
  }, [props.value]);

  const [isAllDay, setIsAllDay] = useState<boolean>(false);

  const isDate = (value: string) =>
    /[0-9]{4}[-][0-9]{2}[-][0-9]{2}/.test(value);

  const isDatetime = (value: string) =>
    isDate(value) && /[T][0-9]{2}[:][0-9]{2}$/.test(value);

  useEffect(() => {
    if (!props.value) return;

    if (!isDate(props.value as string)) return;

    setIsAllDay(!isDatetime(props.value as string));
  }, [props.value]);

  const onToggleAllDay = () => {
    setIsAllDay(!isAllDay);
  };

  const getType = () => {
    if (!props.hasTypeIndicator) {
      return "date";
    }

    return isAllDay ? "date" : "datetime-local";
  };

  useEffect(() => {
    if (props.required && !value) {
      setStatus("ERROR_REQUIRED");
      return;
    }

    setStatus("VALIDATED");
  }, [value, props.required]);

  return (
    <S.Container className="input-date-container">
      <S.Wrapper className="input-date-wrapper">
        <S.WrapperInput className="input-date-wrapper-input">
          <input
            {...{
              name,
              value,
              className: getInformationsClasses(),
              "data-input": "date",
              "data-status": status,
              type: getType(),
              onChange: (event) => {
                const { name, value } = event.target;

                setValue(value);

                props.onChange && props.onChange(name, value, event);
              },
              onBlur: onValidate,
              disabled: props.disabled,
              placeholder: props.placeholder,
            }}
          />
        </S.WrapperInput>

        {props.hasTypeIndicator && (
          <S.WrapperChecklist className="is-all-day-wrapper">
            <Checkbox
              {...{
                id: `all-day-${name}`,
                checked: isAllDay,
                onChange: onToggleAllDay,
                disabled: props.disabled,
              }}
            />
            <Label htmlFor={`all-day-${name}`}>Dia inteiro ?</Label>
          </S.WrapperChecklist>
        )}
      </S.Wrapper>
      <Informations {...{ ref: informationsRef, name, ...informations }} />
    </S.Container>
  );
};
